import React from 'react';
import PropTypes from 'prop-types';
import ChatImage from './ChatImage';
import ChatDocument from './ChatDocument';
import { CHAT_ATTACHMENT_TYPE } from '../../constants/chat';

const ChatAttachment = ({ file, onClick }) => {
  if (file.class_name === CHAT_ATTACHMENT_TYPE.IMAGE)
    return <ChatImage file={file} onClick={() => onClick(file)} />;
  if (file.class_name === CHAT_ATTACHMENT_TYPE.DOCUMENT) return <ChatDocument file={file} />;
  return null;
};

ChatAttachment.propTypes = {
  file: PropTypes.shape({}).isRequired,
  onClick: PropTypes.func.isRequired,
};

export default React.memo(ChatAttachment);



// WEBPACK FOOTER //
// ./app/javascript/common/components/ChatMessage/ChatAttachment.js